import * as RESOURCES from '@constants/resources';
import * as CONST from '@constants/variables';

export const authorizationObject = {
    [RESOURCES.UDP_ORIGIN_ENTRY_POINT]: CONST.SECURITY_PRIVILEGES_READ,
};
